import { get, pick, keyBy, isEmpty } from 'lodash';
import i18next from 'i18next';
import moment from 'moment';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import {
  getCustomFilterMultipleAvailableOrder,
  getCustomFilterMultipleAvailableStock,
  getCustomFilterMultipleAvailableLoss,
  getCustomFilterMultipleAvailableTransfer,
} from '@commons/utils/filtersFetches';

const computeSupplierProductMappings = (supplierProductMappings = [], associatedStores = []) => {
  const storesKeyById = keyBy(associatedStores, 'id');

  return supplierProductMappings.map((mapping) => {
    const matchingStore = storesKeyById[mapping.storeId];

    let nextAvailabilityDate = null;

    if (!isEmpty(mapping.nextAvailability)) {
      nextAvailabilityDate = moment(mapping.nextAvailability.startDate).format(
        DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
      );
    }

    const storeGroups = get(matchingStore, 'groups', []);
    const groupNames = storeGroups.length
      ? storeGroups.map(({ name }) => name)
      : [i18next.t('GENERAL.SELECT_NONE_MASCULINE')]; // only used by advanced filter

    return {
      ...pick(mapping, ['id', 'name', 'storeId', 'hasDlc', 'hasStock', 'available', 'hasTransfer']),
      supplierProfileId: get(matchingStore, 'supplierProfile.id'),
      supplierProfileName: get(matchingStore, 'supplierProfile.name', '-'),
      groups: storeGroups,
      groupNames,
      storeName: get(mapping, 'lnkStoreStoresupplierproductmappingrel.name', '-'),
      storeActive: get(mapping, 'lnkStoreStoresupplierproductmappingrel.active', '-'),
      isCentralKitchenStore: get(
        mapping,
        'lnkStoreStoresupplierproductmappingrel.isKitchen',
        false,
      ),
      nextAvailabilityDate,
      nextAvailabilityValue: get(mapping, 'nextAvailability.available', null),
    };
  });
};

const computeMultipleDropdownsFilter = ({
  supplierProfiles,
  selectedSupplierProfiles,
  setSelectedSupplierProfiles,
  selectedOrderAvailability,
  setSelectedOrderAvailability,
  selectedStockAvailability,
  setSelectedStockAvailability,
  selectedLossAvailability,
  setSelectedLossAvailability,
  selectedTransferAvailability,
  setSelectedTransferAvailability,
}) => {
  const multipleDropdownsFilters = [
    {
      id: 'supplier-profiles',
      icon: '/images/inpulse/supplier-black-small.svg',
      list: supplierProfiles,
      defaultSelectedItems: supplierProfiles,
      selectedItems: selectedSupplierProfiles,
      setSelectedItems: setSelectedSupplierProfiles,
    },
    getCustomFilterMultipleAvailableOrder(selectedOrderAvailability, setSelectedOrderAvailability),
    getCustomFilterMultipleAvailableStock(selectedStockAvailability, setSelectedStockAvailability),
    getCustomFilterMultipleAvailableLoss(selectedLossAvailability, setSelectedLossAvailability),
  ];

  // Callers without transfer handling (e.g. the central product SSPM section) must not expose a
  // filter whose apply would call an undefined setter
  if (setSelectedTransferAvailability) {
    multipleDropdownsFilters.push(
      getCustomFilterMultipleAvailableTransfer(
        selectedTransferAvailability,
        setSelectedTransferAvailability,
      ),
    );
  }

  return multipleDropdownsFilters;
};

export default {
  computeSupplierProductMappings,
  computeMultipleDropdownsFilter,
};
